<template>
    <div>
        <section class="banks-bg">
            <div class="container shape-container pt-md-5">
                <div class="pt-md-5">
                    <div class="col-lg-8 pt-5">
                        <div class="row pt-5">
                            <h3 class="display-2 mt-5">ARE YOU IN THE BANKING SECTOR?
                            <span class="">What are you waiting for?</span>
                            </h3>
                            <p class="lead text-dark mt-0">With TopupBox, you can fulfil the needs of your customers through<br>
                             our platforms with our industry standard and competitive rates
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

         <section class="section px-lg-0 px-4">
            <div class="container">
                <div class="row row-grid align-items-center pb-md-5">
                    <div class="col-md-6 order-md-2" data-aos="fade-left" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                        <div class="pl-md-5">
                            <div class="mb-4">
                                <img src="img/icons/common/enterprise.svg" class="img-fluid">
                            </div>
                            <p>The Bank is a "trust" sector of our economy. And we understand the sensitivity and system behind it. 
                                That's why we built TopupBox with so much attention (to very little details) to give you that 
                                up to date experience, firm reliability and a standard that is both industry fit and globally competitive
                            </p>
                             <p>TopupBox offers banks as much service as it can with the airtime, data and utility transactions. 
                                All of these can easily be done via the website, mobile app, ussd codes, unicard or consuming our APIs for solutions/systems
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 order-md-1">
                        <img src="img/theme/banks-hero.png" class="img-fluid rounded shadow-lg">
                    </div>
                </div>
            </div>
        </section>

        <section class="pb-5 px-lg-0 px-4">
            <div class="container">
                <div class="text-center justify-content-center">
                    <div class="col-lg-12">
                        <h2 class="display-3 text-default">Cases</h2>
                        <p class="lead mb-5">What can you gain as a bank?</p>
                    </div>
                </div>
                <div class="row justify-content-center mb-4">
                    <div class="col-lg-12">
                        <div class="row row-grid" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                            <div class="col-lg-6">
                                <card class="border-0" shadow body-classes="py-5">
                                    <div class="row">
                                        <div class="col-3 d-flex justify-content-center align-items-center">
                                            <div class="mb-4">
                                                <img src="img/icons/common/good.svg" class="img-fluid">
                                            </div>
                                        </div>
                                        <div class="col-9">
                                            <h6 class="text-primary text-uppercase display-4">Competitive Rates</h6>
                                            <p class="description mt-3">
                                                We give you our best charges at resellable rates. 
                                                As low are we can go and you have the advantage of selling at more competitive rates to your customers.
                                            </p>
                                        </div>
                                    </div>
                                </card>
                            </div>
                            <div class="col-lg-6">
                                <card class="border-0" shadow body-classes="py-5">
                                    <div class="row">
                                        <div class="col-3 d-flex justify-content-center align-items-center">
                                            <div class="mb-4">
                                                <img src="img/icons/common/good.svg" class="img-fluid">
                                            </div>
                                        </div>
                                        <div class="col-9">
                                            <h6 class="text-primary text-uppercase display-4">API</h6>
                                            <p class="description mt-3">
                                                Banks can also use our Api to build their platforms to deliver quality service for their customers. Banks can use TopupBox as a Vas management system/partner
                                            </p>
                                        </div>
                                    </div>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid" data-aos="fade-up" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                            <div class="col-lg-6">
                                <card class="border-0" shadow body-classes="py-5">
                                    <div class="row">
                                        <div class="col-3 d-flex justify-content-center align-items-center">
                                            <div class="mb-4">
                                                <img src="img/icons/common/forward.svg" class="img-fluid">
                                            </div>
                                        </div>
                                        <div class="col-9">
                                            <h6 class="text-primary text-uppercase display-4">Enterprise</h6>
                                            <p class="description mt-3">
                                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima dicta doloremque eum placeat quisquam, 
                                                quibusdam aut rerum omnis eaque voluptatum sunt sapiente, 
                                                beatae porro tenetur excepturi, minus sint ut dolorum.
                                            </p>
                                        </div>
                                    </div>
                                </card>
                            </div>
                            <div class="col-lg-6">
                                <card class="border-0" shadow body-classes="py-5">
                                    <div class="row">
                                        <div class="col-3 d-flex justify-content-center align-items-center">
                                            <div class="mb-4">
                                                <img src="img/icons/common/forward.svg" class="img-fluid">
                                            </div>
                                        </div>
                                        <div class="col-9">
                                            <h6 class="text-primary text-uppercase display-4">Enterprise</h6>
                                            <p class="description mt-3">
                                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima dicta doloremque eum placeat quisquam, 
                                                quibusdam aut rerum omnis eaque voluptatum sunt sapiente, 
                                                beatae porro tenetur excepturi, minus sint ut dolorum.
                                            </p>
                                        </div>
                                    </div>
                                </card>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </section>
       
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>